import ChartRangeView, { ChartRangeViewProps } from '../ChartRangeView/ChartRangeView'

function ChartRangeViewLandscape(props: ChartRangeViewProps) {
  return <ChartRangeView {...props} />
}

export default ChartRangeViewLandscape
